import React from "react";

const DownloadSection = () => {
  return (
    <div className="download-area horizontal">
      <div className="bg-overlay"></div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-center mb--55 pt--50">
              <h2 className="text-white">
                DOWNLOAD &nbsp;
                <span className="theme-color text-dark">THE APP</span>
              </h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="download-buttons pb--50">
              <a
                className="download-btn"
                role="button"
                href="https://apps.apple.com/us/app/nibebe-share-a-ride/id1567671939"
              >
                <i className="zmdi zmdi-apple"></i>
                <span>
                  Available on the
                  <span className="large-text">App Store</span>
                </span>
              </a>
              <a
                className="download-btn"
                role="button"
                href="https://play.google.com/store/apps/details?id=com.hudumabomba.safari&gl=US"
              >
                <i className="zmdi zmdi-google-play"></i>
                <span>
                  Available on the
                  <span className="large-text">Play Store</span>
                </span>
              </a>
              {/* <button type="submit" className="download-btn">
                <i className="zmdi zmdi-windows"></i>
                <span>
                  Available on the
                  <span className="large-text">Windows Store</span>
                </span>
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadSection;
